// Material UI
import teal from '@material-ui/core/colors/teal';
import amber from '@material-ui/core/colors/amber';
import blue from '@material-ui/core/colors/blue';
import deepOrange from '@material-ui/core/colors/deepOrange';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import lightGreen from '@material-ui/core/colors/lightGreen';
import lightBlue from '@material-ui/core/colors/lightBlue';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';

// Generic
export const iconPalette = {
  base: 'rgb(97, 97, 97)',
  notification: '#FFF',
  altHeader: '#FFF',
};

export const statusPalette = {
  pending: blue[600],
  success: green[600],
  warning: orange[600],
  error: red[500],
  deprecated: deepOrange[100],
  ignored: grey[400],
  aborted: grey[600],
};

export const occupancyStatePalette = {
  none: grey[500],
  some: blue[400],
  all: blue[600],
  over: orange[600],
};

// Account
export const accountStatusPalette = {
  active: green[400],
  inactive: red[400],
  pending: orange[400],
  mixed: grey[400],
};

// Devices
export const deviceIOStatePalette = {
  up: green[300],
  down: red[300],
  bistable: blue[300],
};

export const deviceNetworkPalette = {
  level0: red[500],
  level1: orange[500],
  level2: amber[500],
  level3: lightGreen[500],
  level4: green[500],
  level5: green[600],
};

export const deviceLogLevelPalette = {
  debug: green[300],
  info: blue[300],
  warning: orange[600],
  error: red[500],
};

// Installations
export const installationLogResultPalette = {
  success: green[600],
  warning: orange[600],
  error: red[500],
};

export const installationScenarioPriorityPalette = {
  low: green[300],
  normal: blue[300],
  high: red[300],
};

// Simcards
export const simcardStatusPalette = {
  unknown: blue[300],
  activation_in_progress: green[300],
  active: green[600],
  inactive: amber[500],
  suspended: orange[600],
};

// Rollouts
export const rolloutStatusPalette = {
  pending: blue[400],
  inProgress: blue[600],
  cancelled: orange[600],
  stopped: orange[700],
  success: green[600],
  error: red[500],
};

// Carparks
export const settingsOnDemand = {
  nbIgnoredPlate: red[500],
};

export const parkingStatusPalette = {
  created: lightBlue[400],
  inProgress: green[600],
  started: green[600],
  finished: grey[700],
  cancelled: orange[500],
  inOverstay: orange[800],
};

export const paymentStatusPalette = {
  inProgress: green[400],
  cancelled: orange[600],
  error: red[500],
  paid: green[600],
  refunded: green[300],
  required: orange[600],
  succeeded: green[600],
};

export const accessResultPalette = {
  success: green[600],
  warning: orange[600],
  error: red[500],
};

export const parkingSpaceStatePalette = {
  busy: red[800],
  free: green[300],
};

export const metricsAccessPalette = {
  total: blue[600],
  input: green[600],
  output: orange[600],
  na: grey[600],
};

export const metricsOccupancyRatePalette = {
  average: blue[600],
  min: green[600],
  max: orange[600],
};

export const metricsRevenuePalette = {
  amountExclTax: green[600],
  amountInclTax: blue[600],
};

// Customers
export const customersAccountStatus = {
  inactive: red[400],
  pending: orange[400],
  active: green[400],
};

// User
export const userRollbackStrategyPalette = {
  alwaysCommit: green[600],
  rollback: orange[600],
};

// Carpark Configuration
export const carparkSpacesTypePalette = {
  bookings: teal[400],
  assigned: orange[400],
  withoutBooking: blue[400],
};



// WEBPACK FOOTER //
// ./components/core/colors/index.js